// extracted by mini-css-extract-plugin
export default {"hero":"About_hero__riQ1l","hero-inner":"About_hero-inner__bgP11","hero-title":"About_hero-title__WZRiv","hero-sub":"About_hero-sub__DRmOs"};